import { useState, useEffect, useCallback } from 'react'

export function useOffline() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine)
  const [pendingSync, setPendingSync] = useState(0)

  useEffect(() => {
    const handleOnline = () => setIsOffline(false)
    const handleOffline = () => setIsOffline(true)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    // Listen for sync completion messages from service worker
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'SYNC_COMPLETE') {
        setPendingSync((prev) => Math.max(0, prev - event.data.synced))
      }
    }

    navigator.serviceWorker?.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
      navigator.serviceWorker?.removeEventListener('message', handleMessage)
    }
  }, [])

  const incrementPending = useCallback(() => {
    setPendingSync((prev) => prev + 1)
  }, [])

  return {
    isOffline,
    isOnline: !isOffline,
    pendingSync,
    hasPendingSync: pendingSync > 0,
    incrementPending,
  }
}
